// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bpmn-container {
  width: 100%;
  height: calc(100%);
  border: var(--border);
  border-radius: var(--border-radius);
  padding: 5px;
}

[data-theme="Dark"] .djs-parent {
  --color-grey-225-10-15: hsl(225, 10%, 15%);
  --color-grey-225-10-35: hsl(225, 10%, 35%);
  --color-grey-225-10-50: hsl(225, 10%, 50%);
  --color-grey-225-10-55: hsl(225, 10%, 55%);
  --color-grey-225-10-70: hsl(225, 10%, 70%);
  --color-grey-225-10-75: hsl(225, 10%, 75%);
  --color-grey-225-10-80: hsl(225, 10%, 80%);
  --color-grey-225-10-85: hsl(225, 10%, 85%);
  --color-grey-225-10-90: hsl(225, 10%, 90%);
  --color-grey-225-10-95: hsl(225, 10%, 95%);
  --color-grey-225-10-97: hsl(225, 10%, 97%);

  --color-blue-205-100-45: hsl(205, 100%, 45%);
  --color-blue-205-100-45-opacity-30: hsla(205, 100%, 45%, 30%);
  --color-blue-205-100-50: hsl(205, 100%, 50%);
  --color-blue-205-100-50-opacity-15: hsla(205, 100%, 50%, 15%);
  --color-blue-205-100-75: hsl(205, 100%, 75%);
  --color-blue-205-100-95: hsl(205, 100%, 95%);

  --color-green-150-86-44: hsl(150, 86%, 44%);

  --color-red-360-100-40: hsl(360, 100%, 40%);
  --color-red-360-100-45: hsl(360, 100%, 45%);
  --color-red-360-100-92: hsl(360, 100%, 92%);
  --color-red-360-100-97: hsl(360, 100%, 97%);

  --color-white: hsl(0, 0%, 100%);
  --color-black: hsl(0, 0%, 0%);
  --color-black-opacity-10: hsla(0, 0%, 0%, 10%);
  --color-black-opacity-30: hsla(0, 0%, 0%, 30%);

  --canvas-fill-color: var(--color-black);

  --bendpoint-fill-color: var(--color-blue-205-100-70);
  --bendpoint-stroke-color: var(--canvas-fill-color);

  --context-pad-entry-background-color: var(--color-black);
  --context-pad-entry-hover-background-color: var(--color-grey-225-10-35);

  --element-dragger-color: var(--color-blue-205-100-70);
  --element-hover-outline-fill-color: var(--color-blue-205-100-95);
  --element-selected-outline-stroke-color: var(--color-blue-205-100-70);
  --element-selected-outline-secondary-stroke-color: var(--color-blue-205-100-50);

  --lasso-fill-color: var(--color-blue-205-100-50-opacity-15);
  --lasso-stroke-color: var(--element-selected-outline-stroke-color);

  --palette-entry-color: var(--color-grey-225-10-85);
  --palette-entry-hover-color: var(--color-blue-205-100-70);
  --palette-entry-selected-color: var(--color-blue-205-100-95);
  --palette-separator-color: var(--color-grey-225-10-35);
  --palette-toggle-hover-background-color: var(--color-grey-225-10-70);
  --palette-background-color: var(--color-grey-225-10-15);
  --palette-border-color: var(--color-grey-225-10-35);

  --popup-font-family: "IBM Plex Sans", sans-serif;
  --popup-font-size: 14px;
  --popup-header-entry-selected-color: var(--color-blue-205-100-70);
  --popup-header-font-weight: bolder;
  --popup-header-group-divider-color: var(--color-grey-225-10-50);
  --popup-background-color: var(--color-black);
  --popup-border-color: transparent;
  --popup-shadow-color: var(--color-black-opacity-10);
  --popup-description-color: var(--color-grey-225-10-70);
  --popup-no-results-color: var(--color-grey-225-10-70);
  --popup-entry-title-color: var(--color-grey-225-10-70);
  --popup-entry-hover-color: var(--color-grey-225-10-35);
  --popup-search-border-color: var(--color-grey-225-10-50);
  --popup-search-focus-border-color: var(--color-blue-205-100-95);
  --popup-search-focus-background-color: var(--color-blue-205-100-50);

  --resizer-fill-color: var(--color-blue-205-100-95);
  --resizer-stroke-color: var(--canvas-fill-color);

  --search-font-family: "IBM Plex Sans", sans-serif;
  --search-font-size: 14px;
  --search-container-background-color: var(--color-black);
  --search-shadow-color: var(--color-black-opacity-30);
  --search-input-border-color: var(--color-grey-225-10-50);
  --search-input-focus-border-color: var(--color-blue-205-100-75);
  --search-input-focus-background-color: var(--color-blue-205-100-45-opacity-30);
  --search-result-hover-background-color: var(--color-grey-225-10-35);
  --search-result-secondary-color: var(--color-grey-225-10-70);
  --search-preselected-background-color: var(--color-blue-205-100-45-opacity-30);

  --shape-attach-allowed-stroke-color: var(--color-blue-205-100-95);
  --shape-connect-allowed-fill-color: var(--color-grey-225-10-97);
  --shape-drop-allowed-fill-color: var(--color-grey-225-10-97);
  --shape-drop-not-allowed-fill-color: var(--color-red-360-100-40);
  --shape-resize-preview-stroke-color: var(--color-blue-205-100-95);

  --snap-line-stroke-color: var(--color-blue-205-100-45-opacity-30);

  --space-tool-crosshair-stroke-color: var(--color-white);

  --tooltip-error-background-color: var(--color-red-360-100-97);
  --tooltip-error-border-color: var(--color-red-360-100-45);
  --tooltip-error-color: var(--color-red-360-100-45);
}



[data-theme="Dark"] .bjs-container {
  --bjs-font-family: Arial, sans-serif;

  --color-grey-225-10-15: hsl(225, 10%, 15%);
  --color-grey-225-10-35: hsl(225, 10%, 35%);
  --color-grey-225-10-55: hsl(225, 10%, 55%);
  --color-grey-225-10-75: hsl(225, 10%, 75%);
  --color-grey-225-10-80: hsl(225, 10%, 80%);
  --color-grey-225-10-85: hsl(225, 10%, 85%);
  --color-grey-225-10-90: hsl(225, 10%, 90%);
  --color-grey-225-10-95: hsl(225, 10%, 95%);
  --color-grey-225-10-97: hsl(225, 10%, 97%);

  --color-blue-205-100-45: hsl(205, 100%, 45%);
  --color-blue-205-100-45-opacity-30: hsla(205, 100%, 45%, 30%);
  --color-blue-205-100-50: hsl(205, 100%, 50%);
  --color-blue-205-100-95: hsl(205, 100%, 95%);

  --color-green-150-86-44: hsl(150, 86%, 44%);

  --color-red-360-100-40: hsl(360, 100%, 40%);
  --color-red-360-100-45: hsl(360, 100%, 45%);
  --color-red-360-100-92: hsl(360, 100%, 92%);
  --color-red-360-100-97: hsl(360, 100%, 97%);

  --color-white: hsl(0, 0%, 100%);
  --color-black: hsl(0, 0%, 0%);
  --color-black-opacity-05: hsla(0, 0%, 0%, 5%);
  --color-black-opacity-10: hsla(0, 0%, 0%, 10%);

  --breadcrumbs-font-family: var(--bjs-font-family);
  --breadcrumbs-item-color: var(--color-blue-205-100-95);
  --breadcrumbs-arrow-color: var(--color-white);
  --drilldown-fill-color: var(--color-black);
  --drilldown-background-color: var(--color-blue-205-100-95);
}
/* Override colors of shapes */
[data-theme="Dark"] .djs-parent .djs-visual path {
   stroke: white !important;
	fill: var(--color-black-opacity-30) !important;
}

[data-theme="Dark"] .djs-parent .djs-visual text {
	fill: white !important;
}

[data-theme="Dark"] .djs-parent .djs-visual rect {
  fill: var(--color-black-opacity-30) !important;
	stroke: white !important;
}

[data-theme="Dark"] .djs-parent .djs-visual circle {
  fill: var(--color-black-opacity-30) !important;
	stroke: white !important;
}


[data-theme="Dark"] .djs-parent .djs-visual polygon {
  fill: var(--color-black-opacity-30) !important;
	stroke: white !important;
}
/* No background color when dragging element onto canvas */
.djs-parent svg.new-parent {
  background: none !important;
}


.djs-context-pad {
  background-color: transparent;
}

.ecl-bpmn-buttons {
  position: absolute;
  bottom: 60px;
  left: 10px;
  display: flex;
}

.bpmn-preview-widget {
  border: var(--border);
  border-radius: var(--border-radius);
  padding: 5px;
  height: 250px;
  width: 300px;
  position: absolute;
  bottom: 50px;
  right: 0px;
}

.bpmn-widget {
  width: 100%;
  height: calc(100% - 50px);
  position: relative;
}

.bpmn-widget .drop-down-trigger {
  position: absolute;
  top: 10px;
  right: 10px;
  border: var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
}

.bpmn-zoom-control-widget {
  position: absolute;
  bottom: 15px;
  right: 80px;
  display: flex;
  align-items: center;
  background-color: transparent;
}


.bpmn-widget button {
  display: flex;
  justify-content: center;
  align-items: center;
  border: var(--border);
  border-radius: var(--border-radius);
}

.bpmn-widget button:hover {
  background-color: #CFCFCF !important;
  color: black
}

[data-theme="Dark"] .bpmn-widget button:hover {
  background-color: #2C2C2C !important;
  color: white;
}
/* This is a catch all css background for all nodes when editing there text content */
[data-theme="Dark"]  .djs-direct-editing-parent {
	border: none !important;
}
[data-theme="Dark"]  .djs-direct-editing-content {
	background-color: #1e1e1e;
	color: #e0e0e0;
	border: 1px solid #3a3a3a;
}
`, "",{"version":3,"sources":["webpack://./src/pages/sandbox/BPMNDemo/BPMNDemo.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;;EAE1C,4CAA4C;EAC5C,6DAA6D;EAC7D,4CAA4C;EAC5C,6DAA6D;EAC7D,4CAA4C;EAC5C,4CAA4C;;EAE5C,2CAA2C;;EAE3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;;EAE3C,+BAA+B;EAC/B,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;;EAE9C,uCAAuC;;EAEvC,oDAAoD;EACpD,kDAAkD;;EAElD,wDAAwD;EACxD,uEAAuE;;EAEvE,qDAAqD;EACrD,gEAAgE;EAChE,qEAAqE;EACrE,+EAA+E;;EAE/E,2DAA2D;EAC3D,kEAAkE;;EAElE,kDAAkD;EAClD,yDAAyD;EACzD,4DAA4D;EAC5D,sDAAsD;EACtD,oEAAoE;EACpE,uDAAuD;EACvD,mDAAmD;;EAEnD,gDAAgD;EAChD,uBAAuB;EACvB,iEAAiE;EACjE,kCAAkC;EAClC,+DAA+D;EAC/D,4CAA4C;EAC5C,iCAAiC;EACjC,mDAAmD;EACnD,sDAAsD;EACtD,qDAAqD;EACrD,sDAAsD;EACtD,sDAAsD;EACtD,wDAAwD;EACxD,+DAA+D;EAC/D,mEAAmE;;EAEnE,kDAAkD;EAClD,gDAAgD;;EAEhD,iDAAiD;EACjD,wBAAwB;EACxB,uDAAuD;EACvD,oDAAoD;EACpD,wDAAwD;EACxD,+DAA+D;EAC/D,8EAA8E;EAC9E,mEAAmE;EACnE,4DAA4D;EAC5D,8EAA8E;;EAE9E,iEAAiE;EACjE,+DAA+D;EAC/D,4DAA4D;EAC5D,gEAAgE;EAChE,iEAAiE;;EAEjE,iEAAiE;;EAEjE,uDAAuD;;EAEvD,6DAA6D;EAC7D,yDAAyD;EACzD,kDAAkD;AACpD;;;;AAIA;EACE,oCAAoC;;EAEpC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;;EAE1C,4CAA4C;EAC5C,6DAA6D;EAC7D,4CAA4C;EAC5C,4CAA4C;;EAE5C,2CAA2C;;EAE3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;;EAE3C,+BAA+B;EAC/B,6BAA6B;EAC7B,6CAA6C;EAC7C,8CAA8C;;EAE9C,iDAAiD;EACjD,sDAAsD;EACtD,6CAA6C;EAC7C,0CAA0C;EAC1C,0DAA0D;AAC5D;AACA,8BAA8B;AAC9B;GACG,wBAAwB;CAC1B,8CAA8C;AAC/C;;AAEA;CACC,sBAAsB;AACvB;;AAEA;EACE,8CAA8C;CAC/C,wBAAwB;AACzB;;AAEA;EACE,8CAA8C;CAC/C,wBAAwB;AACzB;;;AAGA;EACE,8CAA8C;CAC/C,wBAAwB;AACzB;AACA,0DAA0D;AAC1D;EACE,2BAA2B;AAC7B;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA,qFAAqF;AACrF;CACC,uBAAuB;AACxB;AACA;CACC,yBAAyB;CACzB,cAAc;CACd,yBAAyB;AAC1B","sourcesContent":[".bpmn-container {\r\n  width: 100%;\r\n  height: calc(100%);\r\n  border: var(--border);\r\n  border-radius: var(--border-radius);\r\n  padding: 5px;\r\n}\r\n\r\n[data-theme=\"Dark\"] .djs-parent {\r\n  --color-grey-225-10-15: hsl(225, 10%, 15%);\r\n  --color-grey-225-10-35: hsl(225, 10%, 35%);\r\n  --color-grey-225-10-50: hsl(225, 10%, 50%);\r\n  --color-grey-225-10-55: hsl(225, 10%, 55%);\r\n  --color-grey-225-10-70: hsl(225, 10%, 70%);\r\n  --color-grey-225-10-75: hsl(225, 10%, 75%);\r\n  --color-grey-225-10-80: hsl(225, 10%, 80%);\r\n  --color-grey-225-10-85: hsl(225, 10%, 85%);\r\n  --color-grey-225-10-90: hsl(225, 10%, 90%);\r\n  --color-grey-225-10-95: hsl(225, 10%, 95%);\r\n  --color-grey-225-10-97: hsl(225, 10%, 97%);\r\n\r\n  --color-blue-205-100-45: hsl(205, 100%, 45%);\r\n  --color-blue-205-100-45-opacity-30: hsla(205, 100%, 45%, 30%);\r\n  --color-blue-205-100-50: hsl(205, 100%, 50%);\r\n  --color-blue-205-100-50-opacity-15: hsla(205, 100%, 50%, 15%);\r\n  --color-blue-205-100-75: hsl(205, 100%, 75%);\r\n  --color-blue-205-100-95: hsl(205, 100%, 95%);\r\n\r\n  --color-green-150-86-44: hsl(150, 86%, 44%);\r\n\r\n  --color-red-360-100-40: hsl(360, 100%, 40%);\r\n  --color-red-360-100-45: hsl(360, 100%, 45%);\r\n  --color-red-360-100-92: hsl(360, 100%, 92%);\r\n  --color-red-360-100-97: hsl(360, 100%, 97%);\r\n\r\n  --color-white: hsl(0, 0%, 100%);\r\n  --color-black: hsl(0, 0%, 0%);\r\n  --color-black-opacity-10: hsla(0, 0%, 0%, 10%);\r\n  --color-black-opacity-30: hsla(0, 0%, 0%, 30%);\r\n\r\n  --canvas-fill-color: var(--color-black);\r\n\r\n  --bendpoint-fill-color: var(--color-blue-205-100-70);\r\n  --bendpoint-stroke-color: var(--canvas-fill-color);\r\n\r\n  --context-pad-entry-background-color: var(--color-black);\r\n  --context-pad-entry-hover-background-color: var(--color-grey-225-10-35);\r\n\r\n  --element-dragger-color: var(--color-blue-205-100-70);\r\n  --element-hover-outline-fill-color: var(--color-blue-205-100-95);\r\n  --element-selected-outline-stroke-color: var(--color-blue-205-100-70);\r\n  --element-selected-outline-secondary-stroke-color: var(--color-blue-205-100-50);\r\n\r\n  --lasso-fill-color: var(--color-blue-205-100-50-opacity-15);\r\n  --lasso-stroke-color: var(--element-selected-outline-stroke-color);\r\n\r\n  --palette-entry-color: var(--color-grey-225-10-85);\r\n  --palette-entry-hover-color: var(--color-blue-205-100-70);\r\n  --palette-entry-selected-color: var(--color-blue-205-100-95);\r\n  --palette-separator-color: var(--color-grey-225-10-35);\r\n  --palette-toggle-hover-background-color: var(--color-grey-225-10-70);\r\n  --palette-background-color: var(--color-grey-225-10-15);\r\n  --palette-border-color: var(--color-grey-225-10-35);\r\n\r\n  --popup-font-family: \"IBM Plex Sans\", sans-serif;\r\n  --popup-font-size: 14px;\r\n  --popup-header-entry-selected-color: var(--color-blue-205-100-70);\r\n  --popup-header-font-weight: bolder;\r\n  --popup-header-group-divider-color: var(--color-grey-225-10-50);\r\n  --popup-background-color: var(--color-black);\r\n  --popup-border-color: transparent;\r\n  --popup-shadow-color: var(--color-black-opacity-10);\r\n  --popup-description-color: var(--color-grey-225-10-70);\r\n  --popup-no-results-color: var(--color-grey-225-10-70);\r\n  --popup-entry-title-color: var(--color-grey-225-10-70);\r\n  --popup-entry-hover-color: var(--color-grey-225-10-35);\r\n  --popup-search-border-color: var(--color-grey-225-10-50);\r\n  --popup-search-focus-border-color: var(--color-blue-205-100-95);\r\n  --popup-search-focus-background-color: var(--color-blue-205-100-50);\r\n\r\n  --resizer-fill-color: var(--color-blue-205-100-95);\r\n  --resizer-stroke-color: var(--canvas-fill-color);\r\n\r\n  --search-font-family: \"IBM Plex Sans\", sans-serif;\r\n  --search-font-size: 14px;\r\n  --search-container-background-color: var(--color-black);\r\n  --search-shadow-color: var(--color-black-opacity-30);\r\n  --search-input-border-color: var(--color-grey-225-10-50);\r\n  --search-input-focus-border-color: var(--color-blue-205-100-75);\r\n  --search-input-focus-background-color: var(--color-blue-205-100-45-opacity-30);\r\n  --search-result-hover-background-color: var(--color-grey-225-10-35);\r\n  --search-result-secondary-color: var(--color-grey-225-10-70);\r\n  --search-preselected-background-color: var(--color-blue-205-100-45-opacity-30);\r\n\r\n  --shape-attach-allowed-stroke-color: var(--color-blue-205-100-95);\r\n  --shape-connect-allowed-fill-color: var(--color-grey-225-10-97);\r\n  --shape-drop-allowed-fill-color: var(--color-grey-225-10-97);\r\n  --shape-drop-not-allowed-fill-color: var(--color-red-360-100-40);\r\n  --shape-resize-preview-stroke-color: var(--color-blue-205-100-95);\r\n\r\n  --snap-line-stroke-color: var(--color-blue-205-100-45-opacity-30);\r\n\r\n  --space-tool-crosshair-stroke-color: var(--color-white);\r\n\r\n  --tooltip-error-background-color: var(--color-red-360-100-97);\r\n  --tooltip-error-border-color: var(--color-red-360-100-45);\r\n  --tooltip-error-color: var(--color-red-360-100-45);\r\n}\r\n\r\n\r\n\r\n[data-theme=\"Dark\"] .bjs-container {\r\n  --bjs-font-family: Arial, sans-serif;\r\n\r\n  --color-grey-225-10-15: hsl(225, 10%, 15%);\r\n  --color-grey-225-10-35: hsl(225, 10%, 35%);\r\n  --color-grey-225-10-55: hsl(225, 10%, 55%);\r\n  --color-grey-225-10-75: hsl(225, 10%, 75%);\r\n  --color-grey-225-10-80: hsl(225, 10%, 80%);\r\n  --color-grey-225-10-85: hsl(225, 10%, 85%);\r\n  --color-grey-225-10-90: hsl(225, 10%, 90%);\r\n  --color-grey-225-10-95: hsl(225, 10%, 95%);\r\n  --color-grey-225-10-97: hsl(225, 10%, 97%);\r\n\r\n  --color-blue-205-100-45: hsl(205, 100%, 45%);\r\n  --color-blue-205-100-45-opacity-30: hsla(205, 100%, 45%, 30%);\r\n  --color-blue-205-100-50: hsl(205, 100%, 50%);\r\n  --color-blue-205-100-95: hsl(205, 100%, 95%);\r\n\r\n  --color-green-150-86-44: hsl(150, 86%, 44%);\r\n\r\n  --color-red-360-100-40: hsl(360, 100%, 40%);\r\n  --color-red-360-100-45: hsl(360, 100%, 45%);\r\n  --color-red-360-100-92: hsl(360, 100%, 92%);\r\n  --color-red-360-100-97: hsl(360, 100%, 97%);\r\n\r\n  --color-white: hsl(0, 0%, 100%);\r\n  --color-black: hsl(0, 0%, 0%);\r\n  --color-black-opacity-05: hsla(0, 0%, 0%, 5%);\r\n  --color-black-opacity-10: hsla(0, 0%, 0%, 10%);\r\n\r\n  --breadcrumbs-font-family: var(--bjs-font-family);\r\n  --breadcrumbs-item-color: var(--color-blue-205-100-95);\r\n  --breadcrumbs-arrow-color: var(--color-white);\r\n  --drilldown-fill-color: var(--color-black);\r\n  --drilldown-background-color: var(--color-blue-205-100-95);\r\n}\r\n/* Override colors of shapes */\r\n[data-theme=\"Dark\"] .djs-parent .djs-visual path {\r\n   stroke: white !important;\r\n\tfill: var(--color-black-opacity-30) !important;\r\n}\r\n\r\n[data-theme=\"Dark\"] .djs-parent .djs-visual text {\r\n\tfill: white !important;\r\n}\r\n\r\n[data-theme=\"Dark\"] .djs-parent .djs-visual rect {\r\n  fill: var(--color-black-opacity-30) !important;\r\n\tstroke: white !important;\r\n}\r\n\r\n[data-theme=\"Dark\"] .djs-parent .djs-visual circle {\r\n  fill: var(--color-black-opacity-30) !important;\r\n\tstroke: white !important;\r\n}\r\n\r\n\r\n[data-theme=\"Dark\"] .djs-parent .djs-visual polygon {\r\n  fill: var(--color-black-opacity-30) !important;\r\n\tstroke: white !important;\r\n}\r\n/* No background color when dragging element onto canvas */\r\n.djs-parent svg.new-parent {\r\n  background: none !important;\r\n}\r\n\r\n\r\n.djs-context-pad {\r\n  background-color: transparent;\r\n}\r\n\r\n.ecl-bpmn-buttons {\r\n  position: absolute;\r\n  bottom: 60px;\r\n  left: 10px;\r\n  display: flex;\r\n}\r\n\r\n.bpmn-preview-widget {\r\n  border: var(--border);\r\n  border-radius: var(--border-radius);\r\n  padding: 5px;\r\n  height: 250px;\r\n  width: 300px;\r\n  position: absolute;\r\n  bottom: 50px;\r\n  right: 0px;\r\n}\r\n\r\n.bpmn-widget {\r\n  width: 100%;\r\n  height: calc(100% - 50px);\r\n  position: relative;\r\n}\r\n\r\n.bpmn-widget .drop-down-trigger {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  border: var(--border);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.bpmn-zoom-control-widget {\r\n  position: absolute;\r\n  bottom: 15px;\r\n  right: 80px;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: transparent;\r\n}\r\n\r\n\r\n.bpmn-widget button {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border: var(--border);\r\n  border-radius: var(--border-radius);\r\n}\r\n\r\n.bpmn-widget button:hover {\r\n  background-color: #CFCFCF !important;\r\n  color: black\r\n}\r\n\r\n[data-theme=\"Dark\"] .bpmn-widget button:hover {\r\n  background-color: #2C2C2C !important;\r\n  color: white;\r\n}\r\n/* This is a catch all css background for all nodes when editing there text content */\r\n[data-theme=\"Dark\"]  .djs-direct-editing-parent {\r\n\tborder: none !important;\r\n}\r\n[data-theme=\"Dark\"]  .djs-direct-editing-content {\r\n\tbackground-color: #1e1e1e;\r\n\tcolor: #e0e0e0;\r\n\tborder: 1px solid #3a3a3a;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
